import { useAuthContext } from "@app/authContext";
import { BASE_URL } from "@services/api";
import { useState } from "react";

export const useSaveBg = (id: string) => {
  const { auth } = useAuthContext();
    const access_token = auth?.access_token ?? "";

  const [saving, setSaving] = useState<boolean>(false);

  const handleSave = async (data) => {
    setSaving(true);
    const url = `${BASE_URL}/front-bg/card/bg/${id}/model`;
    const payload = {
      components: {
        productBg: {
          ...data
        }
      }
    }

    try {
      const r = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${access_token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!r.ok) throw new Error('HTTP ' + r.status);

      const data = await r.json();
      return data;
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  return {
    saving,
    handleSave
  }
}
